"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _menuItems = _interopRequireDefault(require("./menuItems"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _translations = require("../../libs/translationsUtils/translations");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var menuPlugin = {
  requires: 'codesnippet',
  init: function init(editor) {
    var isUploadForbidden = !(0, _globals.default)('activeModules').includes('nonModeratorsCanUploadImagesAndVideos') && (0, _globals.default)('application') !== 'control';

    var menuItems = _objectSpread({}, _menuItems.default);

    var config = editor.config;
    editor.addMenuGroup('more_tools_group');

    if (isUploadForbidden || !config.showEmbedMedia) {
      delete menuItems.mediaOption;
    }

    if (!config.canHavePoll) {
      delete menuItems.pollOption;
    }

    if (config.profile === 'email') {
      delete menuItems.spoilerOption;
      delete menuItems.mediaOption;
      delete menuItems.tableOption;
    }

    if (config.profile !== 'openingPost') {
      delete menuItems.tableOfContentsOption;
    }

    editor.addMenuItems(menuItems); // @ts-expect-error

    editor.ui.add('More', 'menubutton', {
      label: (0, _translations.t)('Common', 'editor.toolbar.more'),
      modes: {
        wysiwyg: 1
      },
      panel: {
        css: window.CKEDITOR.config.contentsCss
      },
      icon: 'more',
      onMenu: function onMenu() {
        var active = {};
        var isTopicTypeIdea = document.querySelector('.type-idea') !== null;

        var menuItemsCopy = _objectSpread({}, menuItems);

        var isDisablePoll = document.querySelector('.editor-disable-poll') !== null;

        if (isTopicTypeIdea || isDisablePoll) {
          delete menuItemsCopy.pollOption;
        } // Make all items active.


        for (var p in menuItemsCopy) {
          active[p] = 1;
        }

        return active;
      }
    });
  }
};
var _default = menuPlugin;
exports.default = _default;